<template>
  <div class="thumb-container">
    <div class="thumb-content">
      <v-avatar :class="{ 'edit-thumb': edit }" :size="size">
        <v-img
          v-if="thumb"
          :src="thumb"
          :lazy-src="thumb"
          aspect-ratio="1"
          class="item-thumb"
        ></v-img>
        <template
          v-else
        >
          <v-img
            v-if="this.$vuetify.theme.dark"
            src="@/assets/img/avatar_blank_dark.png"
            lazy-src="@/assets/img/avatar_blank_dark.png"
            aspect-ratio="1"
            class="item-thumb"
          ></v-img>
          <v-img
            v-else
            src="@/assets/img/avatar_blank.png"
            lazy-src="@/assets/img/avatar_blank.png"
            aspect-ratio="1"
            class="item-thumb"
          ></v-img>
        </template>
      </v-avatar>
      <v-file-input
        v-if="edit"
        :hide-input="true"
        prepend-icon="mdi-camera"
        filled
        solo
        class="image-upload-input"
        @change="imageUpload"
      ></v-file-input>
      <v-tooltip v-if="(thumb && edit)" top>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            icon
            small
            color="white"
            class="remove-image"
            @click="removeImage"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
        <span>{{ lang.items.new.removeImage }}</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
import appdata from '@/mixins/appdata'

export default {
  mixins: [ appdata ],
  props: {
    photo: {
      type: String,
      default: ''
    },
    size: {
      type: Number,
      default: 54
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    base64: false
  }),
  computed: {
    thumb () {
      let value = this.photo
      return (this.base64 || value === '' || value === null || typeof value === 'undefined' ? value : `${this.app_data.upload_dir}${value}`)
    }
  },
  watch: {
    photo: function (image) {
      if (image) this.base64 = image.includes('data:image')
    }
  },
  methods: {
    removeImage () {
      this.$store.dispatch('setOverlay', true)
      this.$root.$dialog.confirm({
        text: this.lang.items.dialog.thumbDelete,
        title: this.lang.confirm.title,
        waitForResult: true
      }).then(res => {
        this.$store.dispatch('setOverlay', false)
        if (res) this.$emit('changed', '')
      })
    },
    async imageUpload (event) {
      const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        var maxWidth = 450
        reader.onload = function (event) {
          var img = new Image()
          img.src = event.target.result
          img.name = event.target.name
          img.size = event.target.size
          img.onload = function (el) {
            var elem = document.createElement('canvas')
            var scaleFactor = maxWidth / el.target.width

            elem.width = maxWidth
            elem.height = el.target.height * scaleFactor

            var ctx = elem.getContext('2d')
            ctx.drawImage(el.target, 0, 0, elem.width, elem.height)

            var srcEncoded = ctx.canvas.toDataURL(el.target)
            resolve(srcEncoded)
          }
        }
        reader.onerror = error => reject(error)
      })
      var base64Image = await toBase64(event)
      this.$emit('changed', base64Image)
    }
  }
}
</script>

<style lang="scss">
.thumb-container {
  position: relative;
  width: 100%;
  height: 100%;
  .thumb-content {
    position: absolute;
    top: 0px;
    left: 50%;
    transform: translateX(-50%);
    .v-avatar {
      &.edit-thumb {
        border-radius: 5px !important;
      }
      .item-thumb {
        margin: 3px !important;

      }
    }
    .image-upload-input {
      overflow: hidden;
      width: 50px;
      height: 50px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateY(-50%) translateX(-50%);
      background: rgba(0,0,0,0.2);
      .v-input__prepend-outer {
        padding: 0px !important;
        margin: auto !important;
        .v-icon {
          color: #fff;
        }
      }
      .v-input__control {
        display: none;
      }
    }
    .remove-image {
      position: absolute;
      top: 0px;
      right: 0px;
      padding: 7px;
      background: rgba(0,0,0,0.2);
    }
  }
}
</style>
